import { List, Create, Edit, View } from "../Components/index.js";

export default [
    { path: "/store/weekly-menu", component: List, name: "store-weekly-menu-list" },
    { path: "/store/weekly-menu/:id/edit", component: Edit, name: "store-weekly-menu-edit" },
    { path: "/store/weekly-menu/:id/view", component: View, name: "store-weekly-menu-view" },
    { path: "/store/weekly-menu/create", component: Create, name: "store-weekly-menu-create" }
];
